import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function lockScroll() {
  document.body.classList.add('no-scroll');
}

export function unlockScroll() {
  document.body.classList.remove('no-scroll');
}
